/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('adr', [
  'getBroadcast',
]);

function getBroadcast(id) {
  return createAPIAction(
    types.getBroadcast,
    {
      endpoint: `/lora/apps/${id}/broadcasts`,
    })();
}

export default {
  getBroadcast,
};




// WEBPACK FOOTER //
// ./src/redux/actions/broadcast.js